import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-inline-block mr-sm@lg" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  style: {"height":"0.3rem"},
  class: "bg-neutral-750 overflow-hidden w-full my-sm rounded-sm"
}
const _hoisted_4 = { class: "text-xs color-neutral-400" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ButtonIcon = _resolveComponent("ButtonIcon")!
  const _component_ButtonText = _resolveComponent("ButtonText")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Button, {
      color: !_ctx.buttonData?.available ? 'default' : 'accent',
      href: _ctx.authUserMedia?.watch_link,
      target: "_blank",
      class: "mt-md w-full",
      size: "xl",
      isLoading: _ctx.authUserMedia === null,
      isDisabled: !_ctx.buttonData?.available,
      style: {"min-width":"250px"}
    }, {
      default: _withCtx(() => [
        (_ctx.buttonData)
          ? (_openBlock(), _createBlock(_component_ButtonIcon, {
              key: 0,
              name: _ctx.buttonData.icon
            }, null, 8, ["name"]))
          : _createCommentVNode("", true),
        (_ctx.buttonData)
          ? (_openBlock(), _createBlock(_component_ButtonText, { key: 1 }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.buttonData.text), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["color", "href", "isLoading", "isDisabled"]),
    (_ctx.hasPercent)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("span", {
              class: "d-block bg-accent-base h-full rounded-sm",
              style: _normalizeStyle({
            width: _ctx.authUserMedia?.keep_watching?.percent + '%',
          })
            }, null, 4)
          ]),
          _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.transChoice(
            "general.minute_left",
            _ctx.authUserMedia?.keep_watching?.minutes_left
          )), 1)
        ]))
      : _createCommentVNode("", true)
  ]))
}